import { render, staticRenderFns } from "./AxisXTitle.vue?vue&type=template&id=8c45567e&scoped=true&"
import script from "./AxisXTitle.vue?vue&type=script&lang=ts&"
export * from "./AxisXTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AxisXTitle.vue?vue&type=style&index=0&id=8c45567e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c45567e",
  null
  
)

export default component.exports